import { ref } from 'vue'
import { defineStore } from 'pinia'
import i18next from 'i18next'
import type { IChip } from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore.types'

const chipModel: IChip = {
  name: '',
  order: 0,
  isActive: false,
  isVisible: false,
  dropdown: false,
  truncate: false,
  menuChip: false,
  mapChip: false,
  onClick: () => {},
  onReset: undefined,
}

const useChipsStore = defineStore('chipsStore', () => {
  const menuChip = ref<IChip>({ ...chipModel, menuChip: true, order: 1 })
  const updateMenuChip = (newMenuChip: Partial<IChip>) => {
    menuChip.value = { ...menuChip.value, ...newMenuChip }
  }

  const visitLocationChip = ref<IChip>({ ...chipModel, order: 2 })
  const updateVisitLocationChip = (newVisitLocationChip: Partial<IChip>) => {
    visitLocationChip.value = { ...visitLocationChip.value, ...newVisitLocationChip }
  }

  const dateTodayChip = ref<IChip>({ ...chipModel, order: 3 })
  const updateTodayChip = (newTodayChip: Partial<IChip>) => {
    dateTodayChip.value = { ...dateTodayChip.value, ...newTodayChip }
  }

  const dateTomorrowChip = ref<IChip>({ ...chipModel, order: 4 })
  const updateTomorrowChip = (newTomorrowChip: Partial<IChip>) => {
    dateTomorrowChip.value = { ...dateTomorrowChip.value, ...newTomorrowChip }
  }

  const dateWeekendChip = ref<IChip>({ ...chipModel, order: 5 })
  const updateWeekendChip = (newWeekendChip: Partial<IChip>) => {
    dateWeekendChip.value = { ...dateWeekendChip.value, ...newWeekendChip }
  }

  const dateChip = ref<IChip>({ ...chipModel, order: 6 })
  const updateDateChip = (newDateChip: Partial<IChip>) => {
    dateChip.value = { ...dateChip.value, ...newDateChip }
  }

  const cityChip = ref<IChip>({ ...chipModel, order: 7 })
  const updateCityChip = (newCityChip: Partial<IChip>) => {
    cityChip.value = { ...cityChip.value, ...newCityChip }
  }

  const patientAgeChip = ref<IChip>({ ...chipModel, order: 8 })
  const updatePatientAgeChip = (newPatientAgeChip: Partial<IChip>) => {
    patientAgeChip.value = { ...patientAgeChip.value, ...newPatientAgeChip }
  }

  const priceChip = ref<IChip>({ ...chipModel, order: 9 })
  const updatePriceChip = (newPriceChip: Partial<IChip>) => {
    priceChip.value = { ...priceChip.value, ...newPriceChip }
  }

  const placeChip = ref<IChip>({ ...chipModel, order: 10 })
  const updatePlaceChip = (newPlaceChip: Partial<IChip>) => {
    placeChip.value = { ...placeChip.value, ...newPlaceChip }
  }

  const experienceChip = ref<IChip>({ ...chipModel, order: 11 })
  const updateExperienceChip = (newExperienceChip: Partial<IChip>) => {
    experienceChip.value = { ...experienceChip.value, ...newExperienceChip }
  }

  const genderChip = ref<IChip>({ ...chipModel, order: 12 })
  const updateGenderChip = (newGenderChip: Partial<IChip>) => {
    genderChip.value = { ...genderChip.value, ...newGenderChip }
  }

  const categoryChip = ref<IChip>({ ...chipModel, order: 13 })
  const updateCategoryChip = (newCategoryChip: Partial<IChip>) => {
    categoryChip.value = { ...categoryChip.value, ...newCategoryChip }
  }

  const scienceChip = ref<IChip>({ ...chipModel, order: 14 })
  const updateScienceChip = (newScienceChip: Partial<IChip>) => {
    scienceChip.value = { ...scienceChip.value, ...newScienceChip }
  }

  const highRatingChip = ref<IChip>({ ...chipModel, order: 15 })
  const updateHighRatingChip = (newHighRatingChip: Partial<IChip>) => {
    highRatingChip.value = { ...highRatingChip.value, ...newHighRatingChip }
  }

  const diseaseChip = ref<IChip>({ ...chipModel, order: 16 })
  const updateDiseaseChip = (newDiseaseChip: Partial<IChip>) => {
    diseaseChip.value = { ...diseaseChip.value, ...newDiseaseChip }
  }

  const otherSpecialityChip = ref<IChip>({ ...chipModel, order: 17 })
  const updateOtherSpecialityChip = (newOtherSpecialityChip: Partial<IChip>) => {
    otherSpecialityChip.value = { ...otherSpecialityChip.value, ...newOtherSpecialityChip }
  }

  const appointmentChip = ref<IChip>({ ...chipModel, order: 18 })
  const updateAppointmentChip = (newAppointmentSwitchChip: Partial<IChip>) => {
    appointmentChip.value = { ...appointmentChip.value, ...newAppointmentSwitchChip }
  }

  const clubSwitchChip = ref<IChip>({ ...chipModel, order: 19 })
  const updateClubSwitchChip = (newClubSwitchChip: Partial<IChip>) => {
    clubSwitchChip.value = { ...clubSwitchChip.value, ...newClubSwitchChip }
  }

  const mapChip = ref<IChip>({
    ...chipModel,
    order: 20,
    name: i18next.t('На карте', { ns: i18next.language }),
    isVisible: true,
    mapChip: true,
  })

  return {
    mapChip,
    menuChip,
    cityChip,
    dateChip,
    dateTodayChip,
    dateTomorrowChip,
    dateWeekendChip,
    priceChip,
    placeChip,
    genderChip,
    scienceChip,
    diseaseChip,
    categoryChip,
    experienceChip,
    patientAgeChip,
    highRatingChip,
    clubSwitchChip,
    otherSpecialityChip,
    visitLocationChip,
    appointmentChip,
    updateMenuChip,
    updateCityChip,
    updateDateChip,
    updateTodayChip,
    updateTomorrowChip,
    updateWeekendChip,
    updatePriceChip,
    updatePlaceChip,
    updateGenderChip,
    updateScienceChip,
    updateDiseaseChip,
    updateCategoryChip,
    updateExperienceChip,
    updatePatientAgeChip,
    updateHighRatingChip,
    updateClubSwitchChip,
    updateOtherSpecialityChip,
    updateVisitLocationChip,
    updateAppointmentChip,
  }
})

export default useChipsStore
